const hasMortgageCalculator = (priceQualifier: string): boolean => {
    return !['price_on_request', 'sale_by_tender', 'non_quoting'].includes(
        priceQualifier
    );
};

export default hasMortgageCalculator;
